<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/dashboard">
        <img v-show="src" :src="src" class="sidebar-logo">
        <svg-icon v-show="!src" class="logo" icon-class="LOGO" />
        <h1 class="sidebar-title">{{ title }} </h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/dashboard">
        <img v-show="src" :src="src" class="sidebar-logo">
        <svg-icon v-show="!src" class="logo" icon-class="LOGO" />
        <h1 class="sidebar-title">{{ title }} </h1>
      </router-link>
    </transition>
    <Recharge v-if="rechargeShow" :type="11" :title="rechargeTitle" :visible.sync="rechargeShow" @func="closeRecharge" />
  </div>
</template>

<script>
import { getSiteInfo } from '../../../api/login'
import Recharge from '@/views/recharge'

export default {
  name: 'SidebarLogo',
  components: {
    Recharge
  },
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    // 侧边栏头部信息
    return {
      title: '业财系统',
      logo: './../../../assets/imgs/SIDE_LOGO.png',
      src: '',
      expire_time: '',
      days: 0,
      rechargeShow: false
    }
  },
  computed: {
    rechargeTitle() {
      return `在线续费（到期时间：${this.expire_time}）`
    }
  },
  mounted() {
    this.getSiteInfo()
  },
  methods: {
    async getSiteInfo() {
      const res = await getSiteInfo()
      if (res.code === 200) {
        this.title = res.data.title ? res.data.title : '业财系统'
        this.src = res.data.logo
        this.expire_time = res.data.effectiveEndTime
        this.expire_time = this.getYearMonth(this.expire_time).join('-')
        this.expireDay()
      }
    },
    getYearMonth(date) {
      date = (date + '').split(/[ ]+/)
      const result = []
      const reg = /^(\d{4})-(\d{1,2})-(\d{1,2})$/
      // 用截取出来的年月日进行正则表达式匹配
      reg.exec(date[0])
      result.push(RegExp.$1)
      result.push(RegExp.$2)
      result.push(RegExp.$3)
      return result
    },
    remind() {
      const _this = this
      const h = this.$createElement
      this.$notify({
        title: '站点到期时间',
        dangerouslyUseHTMLString: true,
        message: h('strong', null, [
          h('span', null, '日期: '),
          h('span', { style: 'padding-right: 8px;' }, _this.expire_time),
          h('span', null, '剩余'),
          _this.days === 0
            ? h('span', { style: 'color: #F56C6c' }, '不足24小时')
            : h('span', { style: 'color: #F56C6c' }, `${_this.days}天`),
          h('div', null, [
            h('span', null, '续费：'),
            h(
              'el-link',
              {
                props: { type: 'primary', underline: false },
                on: { click: _this.handleBuy }
              },
              '在线支付'
            )
          ])
        ]),
        type: 'warning'
      })
    },
    handleBuy() {
      this.rechargeShow = true
    },
    closeRecharge() {
      this.rechargeShow = false
    },
    expireDay() {
      const _day = new Date(this.expire_time).getTime()
      const _nowTime = new Date().getTime()
      const _differ = Math.abs(_day - _nowTime)
      this.days = Math.floor(_differ / (24 * 3600 * 1000))
      if (this.expire_time) {
        if (this.days < 30 || this.days === 30) {
          this.remind()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 80px;
  line-height: 80px;
  background: #172137;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px !important;
      height: 32px !important;
      vertical-align: middle;
      margin-right: 12px;
    }
    & .logo {
      height: 36px;
      width: 36px;
      line-height: 36px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 16px;
      letter-spacing: 2px;
      // font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
